(function() {
    'use strict';
    angular
        .module('MW.ContactManager.OutreachList', ['ngMaterial', 'pascalprecht.translate'])
        .component('outreachList', {
            templateUrl: 'icm-web/views/partials/outreach_list_component',
            bindings: {
                items: '=',
                isInitializing: '<',
                total: '<',
                pageNumber: '<',
                handlePage: '&',
                onDelete: '&',
                onDuplicate: '&',
                onFilterByStatus: '&',
                loadPromise: '&',
                selectedItems: '<',
                sortField: '<',
                sortOrder: '<',
                onSortChange: '&',
                onFindTextChange: '&',
                findText: '<',
                composeFunction: '&'
            },
            controller: OutreachListComponentController
        })
        .controller('OutreachListComponentController', [
            '$window',
            '$mdMedia',
            '$location',
            '$translate',
            '$document',
            OutreachListComponentController
        ]);

        function OutreachListComponentController($window, $mdMedia, $location, $translate, $document) {
            var _this = this;
            this.$window = $window;
            this.$mdMedia = $mdMedia;
            this.$location = $location;
            this.selectedItems = [];
            this.isDataLoaded = true;


            this.$onInit = function(){
                this.findText = this.findText || '';
                this.isSearchActive = !!this.findText;

                this.paging = {
                    itemsPerPage: 25,
                    selectedPage: this.pageNumber || 1,
                    totalItems: 0
                };

                this.setSortField = function(sortField, sortOrder){
                    //Default Sorting
                    var orderObj = {
                        column: '-scheduledDateStamp',
                        descending: true
                    };

                    if(sortOrder){
                        orderObj.descending = (sortOrder !== 'ASC');
                    }

                    if(sortField){
                        orderObj.column = orderObj.descending ? '-' + sortField : sortField;
                    }

                    return orderObj;
                };

                this.orderBy = this.setSortField(this.sortField, this.sortOrder);



                this.tablePaginationLabel = {
                    of: 'mw-collection__table-pagination-of'
                };

                $translate(this.tablePaginationLabel.of).then(function(message) {
                    this.tablePaginationLabel.of = message;
                }.bind(this));

                this.isHeaderTitleVisible = function() {
                    return !($mdMedia('xs') && this.isSearchActive);
                };

                this.filterBy = 'All';
                this.setFilterBy = function(status) {
                    var state = '';
                    switch (status) {
                        case 'draft':
                            this.filterBy = 'Drafts';
                            state = 'draft';
                            break;
                        case 'scheduled':
                            this.filterBy = 'Scheduled';
                            state = 'scheduled';
                            break;
                        case 'sent':
                            this.filterBy = 'Sent';
                            state = 'sent';
                            break;
                        default:
                            this.filterBy = 'All';
                            break;
                    }

                    if(!this.isInitializing){
                        this.paging.selectedPage = 1;
                        this.items = [];
                        this.isDataLoaded = false;
                        this.loadPromise = this.onFilterByStatus({
                            filterByType: state
                        }).then(function(){
                            _this.isDataLoaded = true;
                        });
                    }
                };
                if (this.$location.search().filterByStatusType) {
                    this.setFilterBy(this.$location.search().filterByStatusType);
                }

                this.onSearchToggle = function(isSearchActive) {
                    this.isSearchActive = isSearchActive;
                };

                this.isDataLoading = function() {
                    return !this.isDataLoaded;
                };

                this.isSearchVisible = function() {
                    return true;
                };

                this.isCurrentSortColumn = function(column) {
                    return this.orderBy.column.replace('-', '') === column;
                };

                this.isAscending = function() {
                    return !this.orderBy.descending;
                };

                this.setColumn = function(column, shouldUpdateOrderBy) {
                    if (shouldUpdateOrderBy) {
                        if (column !== _this.orderBy.column.replace('-', '')) {
                            if (!_this.orderBy.descending) {
                                _this.orderBy.column = column;
                            } else {
                                _this.orderBy.column = '-' + column;
                            }
                        }
                    } else {
                        if (column.charAt(0) === '-') {
                            _this.orderBy.descending = true;
                        } else {
                            _this.orderBy.descending = false;
                        }
                    }
                    _this.sortChanged();
                };

                this.shouldSetMaxWidth = function() {
                    return this.$mdMedia('md') || this.$mdMedia('sm');
                };

                this.setOrder = function(isDescending) {
                    if (isDescending !== this.orderBy.descending) {
                        this.orderBy.descending = isDescending;
                        if (!isDescending) {
                            this.orderBy.column = this.orderBy.column.replace('-', '');
                        } else {
                            this.orderBy.column = '-' + this.orderBy.column;
                        }
                    }
                    this.sortChanged();
                };

                this.resetPagination = function() {
                    if (this.paging.selectedPage !== 1) {
                        this.paging.selectedPage = 1;
                    }
                };

                this.sortChanged = function sortChanged(){
                    if(!this.isInitializing){
                        this.resetPagination();
                        this.items = [];
                        this.isDataLoaded = false;
                        this.loadPromise = this.onSortChange({column: this.orderBy.column, order: this.orderBy.descending}).then(function(){
                            _this.isDataLoaded = true;
                        });
                    }
                };

                if (this.$location.search().sortField || this.$location.search().sortOrder) {
                    this.setColumn(this.$location.search().sortField, (this.$location.search().sortOrder === 'DESC'));
                }

                this.onRowClick = function(item) {
                    if (item.distributionStatus === 'sent' || item.distributionStatus === 'sending') {
                        this.$location.url(this.getItemPreviewUrl(item._id));
                    } else if (this.canEditEmail(item)) {
                        this.$location.url(this.getItemEditUrl(item._id));
                    }
                };

                this.search = function(findText) {
                    if(!this.isInitializing && (findText.length === 0 || findText.length >= 3)) {
                        this.items = [];
                        this.isDataLoaded = false;
                        this.loadPromise = this.onFindTextChange({findText: findText}).then(function(){
                            _this.isDataLoaded = true;
                        });

                        this.resetPagination();
                    }
                };

                this.canEditEmail = function(item) {
                    return item.distributionStatus === 'draft' || item.distributionStatus === 'scheduled' || item.distributionStatus === 'errors';
                };

                this.handleEditEmail = function(item) {
                    this.$location.url(this.getItemEditUrl(item._id));
                };

                this.handlePreviewEmail = function(item) {
                    this.$location.url(this.getItemPreviewUrl(item._id));
                };

                this.isHeaderDuplicateButtonEnabled = function() {
                    return this.selectedItems.length === 1;
                };

                this.isEmptyStateVisible = function() {
                    return (!this.isDataLoading() && !this.isInitializing && ((this.filteredItems && this.filteredItems.length === 0) || this.items.length === 0));
                };

                this.resetSelectedItems = function() {
                    this.selectedItems = [];
                };

                this.page = function(e){
                    this.items = [];
                    this.resetTableScroll();
                    this.isDataLoaded = false;
                    this.loadPromise = this.handlePage({$event: e}).then(function() {
                        _this.isDataLoaded = true;
                    });
                }.bind(this);

                this.handleSingleDelete = function(event, item) {
                    /* ContactManagerOutreachListController expects an array of ids. This lets us avoid
                        having to change the controller behavior */
                    var itemIdArr = [item._id];

                    this.loadPromise = this.onDelete({
                        $event: event,
                        itemIdArr: itemIdArr
                    });
                };

                this.handleBulkDelete = function(event) {
                    this.loadPromise = this.onDelete({
                        $event: event,
                        itemIdArr: this.selectedItems
                    });
                };

                this.handleSingleDuplicate = function(event, item) {
                    /* ContactManagerOutreachListController expects an array of ids. This lets us avoid
                        having to change the controller behavior */
                    var itemObj;

                    if (Array.isArray(item)) {
                        this.items.some(function(email) {
                            if (email._id === item[0]) {
                                itemObj = email;
                                return true;
                            }
                        });
                    }

                    this.onDuplicate({
                        $event: event,
                        item: itemObj ? itemObj : item
                    });
                };

                this.resetTableScroll = function() {
                    var mdContentWrapperElementSelector = 'div.mi-app-chrome-content__app-content-slot';
                    var dashboardTableId = '#mw-newswire-outreach-list__content';
                    var tableEl = angular.element($document[0].querySelector(dashboardTableId));
                    var mdContentEl = angular.element($document[0].querySelector(mdContentWrapperElementSelector));
                    if (tableEl && mdContentEl) {
                        mdContentEl.scrollTop(tableEl[0].offsetTop);
                    }
                };

                this.getItemPreviewUrl = function(itemId) {
                    return '/influencers/contact/outreach/' + itemId;
                };

                this.getItemEditUrl = function(itemId) {
                    return '/outreach/compose/' + itemId;
                };

                this.compose = function compose() {
                    this.composeFunction({distribution: undefined, state: undefined});
                };
            };
    }
}());
